export class Cache<K extends string | number | symbol, T> {
	cache: Record<K, T> = {} as Record<K, T>
	getValue(key: K, forceRefresh?: boolean): T {
		let res = this.cache[key]
		if (typeof res == 'undefined' || forceRefresh) {
			const res = this.retrieveValue(key)
			this.cache[key] = res
		}
		return res
	}
	protected retrieveValue(key: K): T {
		throw new Error('Method not implemented.')
	}
	hasValue(key: K): boolean {
		return typeof this.cache[key] != 'undefined'
	}
	setValue(key: K, val: T): void {
		this.cache[key] = val
	}
	deleteValue(key: K): void {
		delete this.cache[key]
	}
	clear(): void {
		this.cache = {} as Record<K, T>
	}
}
export class AsyncCache<K extends string | number | symbol, T> {
	cache: Record<K, T> = {} as Record<K, T>
	async getValue(key: K, forceRefresh?: boolean): Promise<T> {
		let res = this.cache[key]
		if (typeof res == 'undefined' || forceRefresh) {
			res = await this.retrieveValue(key)
			this.cache[key] = res
		}
		return await res
	}
	protected async retrieveValue(key: K): Promise<T> {
		throw new Error('Method not implemented.')
	}
	hasValue(key: K): boolean {
		return typeof this.cache[key] != 'undefined'
	}
	setValue(key: K, val: T): void {
		this.cache[key] = val
	}
	deleteValue(key: K): void {
		delete this.cache[key]
	}
	clear(): void {
		this.cache = {} as Record<K, T>
	}
}
